import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConnectionCredentialsModalComponent } from './connection-credentials-modal/connection-credentials-modal.component';
import { MarketplaceConnection } from '@models/configuration/marketplace/marketplace-connection-model';
import { StoreService } from '../../store.service';
import { isNilty } from '@core/utils.service';

@Component({
  selector: 'app-account-connections',
  templateUrl: './account-connections.component.html',
  styleUrls: ['./account-connections.component.scss'],
})
export class AccountConnectionsComponent implements OnInit {
  connections: MarketplaceConnection[] = [];
  filteredConnections: MarketplaceConnection[] = [];
  searchString = '';
  loaded = false;

  constructor(private dialog: MatDialog, public dialogRef: MatDialogRef<AccountConnectionsComponent>, private storeService: StoreService) {}

  ngOnInit() {
    this.storeService.findMarketplaceConnections().subscribe((r) => {
      this.connections = r.sort((a, b) => (a.name > b.name ? 1 : -1));
      this.loaded = true;
      this.filterConnections();
    });
  }

  filterConnections() {
    if (isNilty(this.searchString?.trim())) {
      this.filteredConnections = [...this.connections];
      return;
    }

    const strToSearch = this.searchString.toUpperCase().trim();
    this.filteredConnections = this.connections.filter(
      (c) => c.name?.toUpperCase().includes(strToSearch) || c.marketplaceConnectionType?.toUpperCase().includes(strToSearch)
    );
  }

  editConnection(connection: MarketplaceConnection) {
    this.dialog.open(ConnectionCredentialsModalComponent, { data: connection });
  }
}
